/* unplugin-vue-components disabled */import script from "./miner_rank.vue?vue&type=script&setup=true&lang=js"
export * from "./miner_rank.vue?vue&type=script&setup=true&lang=js"

import "./miner_rank.vue?vue&type=style&index=0&id=0da0d92d&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0da0d92d"]])

export default __exports__